import {bootstrapModules} from './allModules'
import {checkAndUpdateXRobots} from '../lib/xrobots'

// Update xrobots to noindex, nofollow if the domain is a bad-actor cloned site, else run the main script
checkAndUpdateXRobots(bootstrapModules)
